module.exports = __webpack_public_path__ + "static/media/cockpit_bg.6010d777.svg";